<div
  class="hx-confirmation-popup__container"
  [class.hx-confirmation-popup--warning]="variant() === 'warning'"
  [class.hx-confirmation-popup--success]="variant() === 'success'"
  [class.hx-confirmation-popup--error]="variant() === 'error'"
  [class.hx-confirmation-popup--info]="variant() === 'info'"
  [class.hx-confirmation-popup--variant-body]="applyVariantToBody()"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="'popup-header'"
  [attr.aria-describedby]="'popup-body'"
  tabindex="-1"
  (keydown)="handleKeyDown($event)">
  <!-- Close Icon (Absolute positioned) -->
  @if (showCancelIcon()) {
    <div class="hx-confirmation-popup__close">
      <button
        #closeButton
        hxIconButton
        context="neutral"
        type="button"
        variant="outline"
        svgIcon="ccs-x"
        size="sm"
        title="Close"
        (click)="handleCancel()"></button>
    </div>
  }

  <!-- Header -->
  <div class="hx-confirmation-popup__header" id="popup-header">
    @if (headerTemplate()) {
      <ng-container *ngTemplateOutlet="headerTemplate()"></ng-container>
    } @else if (headerText()) {
      <div class="hx-confirmation-popup__header-content">
        @if (headerIcon()) {
          <hx-icon [svgIcon]="headerIcon()!" class="hx-confirmation-popup__header-icon" aria-hidden="true"></hx-icon>
        }
        <span>{{ headerText() }}</span>
      </div>
    }
  </div>

  <!-- Divider -->
  <hx-divider></hx-divider>

  <!-- Body -->
  <div class="hx-confirmation-popup__body" id="popup-body">
    @if (bodyTemplate()) {
      <ng-container *ngTemplateOutlet="bodyTemplate()"></ng-container>
    } @else if (message()) {
      <p>{{ message() }}</p>
    } @else {
      <ng-content />
    }
  </div>

  <!-- Footer Actions -->
  @if (showAcceptButton() || showCancelButton()) {
    <div class="hx-confirmation-popup__footer">
      @if (showCancelButton()) {
        <button hxButton variant="outline" context="neutral" (click)="handleCancel()">
          {{ cancelLabel() }}
        </button>
      }
      @if (showAcceptButton()) {
        <button
          hxButton
          variant="fill"
          [context]="getAcceptButtonContext()"
          [disabled]="acceptDisabled()"
          (click)="handleAccept()">
          {{ acceptLabel() }}
        </button>
      }
    </div>
  }
</div>
